import { useQuery } from '@tanstack/react-query';
import { invitationCodeService } from '@/services/invitationCodeService';

// Query keys
export const invitationCodeKeys = {
  all: ['invitationCodes'] as const,
  owners: () => [...invitationCodeKeys.all, 'owners'] as const,
};

/**
 * Get public owners (agents)
 */
export function usePublicOwners() {
  return useQuery({
    queryKey: invitationCodeKeys.owners(),
    queryFn: async () => {
      const result = await invitationCodeService.getPublicOwners();
      if (result.error) throw new Error(result.error.message);
      return result.data;
    },
    gcTime: 0,
    staleTime: 0,
  });
}
